import styled from 'styled-components';

import { color, spacing } from '~/theme';

export const StyledFormGroup = styled.div<{
    $errors?: boolean;
    $calloutErrorBorder?: boolean;
}>`
    margin-bottom: ${spacing.spacing6};
    border-left: ${props =>
        props.$calloutErrorBorder && props.$errors && `4px solid ${color.calloutErrorBorder}`};
    padding-left: ${props => props.$calloutErrorBorder && props.$errors && `${spacing.spacing4}`};
`;

export default {
    StyledFormGroup,
};
